export function createSearchParams(searchTerm, allowedParams, defaultParam = 'name') {
    // search can look like this: name:"Test Bert", country:AT
    let searchParamObj = {};
    const searchParamMap = getSearchParamMap(searchTerm, allowedParams, defaultParam);
    searchParamMap.forEach(param => {
        searchParamObj[param.name] = param.value
    });
    return searchParamObj;
}

export function getSearchParamMap(searchTerm, allowedParams, defaultParam = 'name') {
    let searchParamMap = [];
    if (searchTerm.includes(':')) {
        const splitParams = searchTerm.split(';');
        if (!splitParams) return searchParamMap;
        splitParams.forEach(param => {
            if (param.includes(':')) {
                param = param.trim();
                const firstColonIndex = param.indexOf(':')
                const paramKey = param.slice(0, firstColonIndex).trim();
                let paramValue = param.slice(firstColonIndex + 1).trim();
                if (allowedParams.includes(paramKey)) {
                    paramValue = paramValue.replace(/['"]+/g, '');
                    searchParamMap.push({
                        name: paramKey,
                        value: paramValue,
                    });
                }
            }
        });
    } else {
        searchParamMap.push({
            name: defaultParam,
            value: searchTerm,
        });
    }
    return searchParamMap;
}
